module.exports = __webpack_public_path__ + "static/ob-gyn-c5fb8fbe54cdf6dc4cd3ccf20ba77526.jpg";